import { Flex, DisplaySwitch, Card, ChartSkeleton } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import AtRiskChartPerDrop from './AtRiskChartPerDrop';
import AtRiskChartPerDropCumulative from './AtRiskChartPerDropCumulative';
import AtRiskHistoryChart from './AtRiskHistoryChart';
import { ChartTimeFilter } from '@/components';
import { useApi } from '@/api';
import type { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

export default function AtRiskTabs() {
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('at-risk-cumulatuve');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const displayOptions = useMemo(
    () => [
      { key: 'at-risk-cumulatuve', value: 'At Risk' },
      { key: 'at-risk-drop', value: 'At Risk - Per Drop' },
      { key: 'at-risk-historic', value: 'At Risk - Historic' }
    ],
    []
  );

  const [data, error] = useApi<SimpleChartData[]>({
    url: `/at-risk/`
  });

  if (error) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const content = useMemo(() => {
    switch (activeDisplayOption) {
      case 'at-risk-cumulatuve':
        return data ? (
          <AtRiskChartPerDropCumulative data={data} />
        ) : (
          <ChartSkeleton />
        );
      case 'at-risk-drop':
        return data ? <AtRiskChartPerDrop data={data} /> : <ChartSkeleton />;
      case 'at-risk-historic':
        return <AtRiskHistoryChart chartDaysAgo={chartDaysAgo} />;
      default:
        return null;
    }
  }, [activeDisplayOption, chartDaysAgo, data]);

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        alignItems={['center', 'flex-start']}
        flexDirection={['column', 'row']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        {activeDisplayOption === 'at-risk-historic' ? timeFilter : null}
      </Flex>
      {content}
    </Card>
  );
}
